import { EmailUtils, EmailValidator } from '@skylab-shared/business';
import { MaxLength, ShortLength, VeryLongLength, ViolationSeverity } from '@skylab-shared/core';

export interface IEmailValidation {
    source: {
        sun: string;
    };
    propertyName: string;
    ruleViolation: {
        violation: {
            severity: ViolationSeverity;
            message: string;
            messageParams?: unknown;
        };
    };
}

export class EmptyEmailErrorValidator {

    public execute(propertyName: string, value: any): IEmailValidation | null {
        return value ? null : this.getValidationResult(propertyName);
    }

    protected getValidationResult(propertyName: string): IEmailValidation {
        return {
            source: {
                sun: 'send-email-dialog-context'
            },
            propertyName: propertyName,
            ruleViolation: {
                violation: {
                    severity: ViolationSeverity.Error,
                    message: 'scenes.shared.dialog.send-email.validations.email.empty'
                }
            }
        };
    }
}

export class NotValidEmailErrorValidator {

    public execute(propertyName: string, value: string): IEmailValidation | null {
        if (!value) return null;
        const emails = EmailUtils.extractEmails(value);
        const invalidEmails = EmailValidator.getInvalidEmailsFromArray(emails);
        const isValid = invalidEmails.length <= 0;
        return isValid ? null : this.getValidationResult(propertyName, invalidEmails);
    }

    protected getValidationResult(propertyName: string, invalidEmails: string[]): IEmailValidation {
        return {
            source: {
                sun: 'send-email-dialog-context'
            },
            propertyName: propertyName,
            ruleViolation: {
                violation: {
                    severity: ViolationSeverity.Error,
                    message: 'scenes.shared.dialog.send-email.validations.email.not-valid',
                    messageParams: { emails: EmailUtils.concatEmails(invalidEmails) }
                }
            }
        };
    }
}

export class ContentLengthErrorValidator {

    public execute(propertyName: string, value: any): IEmailValidation | null {
        return value?.length > MaxLength ? this.getValidationResult(propertyName) : null;
    }

    protected getValidationResult(propertyName: string): IEmailValidation {
        return {
            source: {
                sun: 'send-email-dialog-context'
            },
            propertyName: propertyName,
            ruleViolation: {
                violation: {
                    severity: ViolationSeverity.Error,
                    message: 'scenes.shared.dialog.send-email.validations.email.content.length'
                }
            }
        };
    }
}

export class SubjectLengthErrorValidator {

    public execute(propertyName: string, value: any): IEmailValidation | null {
        return value?.length > VeryLongLength ? this.getValidationResult(propertyName) : null;
    }

    protected getValidationResult(propertyName: string): IEmailValidation {
        return {
            source: {
                sun: 'send-email-dialog-context'
            },
            propertyName: propertyName,
            ruleViolation: {
                violation: {
                    severity: ViolationSeverity.Error,
                    message: 'scenes.shared.dialog.send-email.validations.email.subject.length'
                }
            }
        };
    }
}

export class SenderNameLengthErrorValidator {

    public execute(propertyName: string, value: any): IEmailValidation | null {
        return value?.length > ShortLength ? this.getValidationResult(propertyName) : null;
    }

    protected getValidationResult(propertyName: string): IEmailValidation {
        return {
            source: {
                sun: 'send-email-dialog-context'
            },
            propertyName: propertyName,
            ruleViolation: {
                violation: {
                    severity: ViolationSeverity.Error,
                    message: 'scenes.shared.dialog.send-email.validations.email.sender-name.length'
                }
            }
        };
    }
}
